import { render, staticRenderFns } from "./feeConfigManageList.vue?vue&type=template&id=fc63b16a&scoped=true"
import script from "./feeConfigManageList.vue?vue&type=script&lang=js"
export * from "./feeConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./feeConfigManageList.vue?vue&type=style&index=0&id=fc63b16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc63b16a",
  null
  
)

export default component.exports